export const latestLinks = (apiKey: string) => `
query LatestLinks {
  hotLinks(apiKey: "${apiKey}") {
    items {
      created
      id
      opened
      redirectTo
      url
    }
  }
  lastLinks(apiKey: "${apiKey}") {
    items {
      created
      id
      redirectTo
      url
    }
  }
}`;
